
























import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";

/**
 * Components
 */
import CharacterCell from "@/components/_global/CharacterCell.vue";

/**
 * Types
 */

/**
 * VueX Modules
 */

/**
 * A characters' repartition table by users.
 */
@Component({
	components: {
		CharacterCell
	}
})
export default class UsersRepartitionTable extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;

	/// Properties
	@Prop()
	rosters!: any[];

	/// Attributes
	get headers() {
		return [
			// {
			// 	text: "",
			// 	value: "userID",
			// 	align: "left",
			// 	class: "collapsing"
			// },
			...this.rosters
				.map((roster: any) =>
					({
						text: roster.name,
						value: roster.id,
						align: "center",
						class: "collapsing"
					})
				)
		];
	}

	get items() {
		const result = [];
		for (const roster of this.rosters) {
			for (const character of roster.characters) {
				const existingElementInResult = result.find(x => x.userID === character.userID);
				if (existingElementInResult != null) {
					if (existingElementInResult[roster.id] != null) {
						existingElementInResult[roster.id].push(character);
					}
					else {
						existingElementInResult[roster.id] = [character];
					}

				}
				else {
					result.push({
						userID: character.userID,
						[roster.id]: [character]
					});
				}
			}
		}

		return result;

		// return this.rosters.reduce((prev: any[], curr: any) => {
		// 	if () {
		// 		return [
		// 			...prev,
		// 			{
		// 				id: .userID
		// 			}
		// 		];
		// 	}
		// 	else {
		// 		return prev;
		// 	}
		// }, []);
	}

	/// Methods
	getSlotName(rosterID: string) {
		return `item.${rosterID}`;
	}
}
